import { sqliteTable, text, real, integer, index, uniqueIndex } from "drizzle-orm/sqlite-core";

// ============================================================================
// fixed_assets — สินทรัพย์ถาวร (Fixed Asset)
// ============================================================================
export const fixedAssets = sqliteTable("accounting_fixed_assets", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  assetCode: text("asset_code").notNull(),
  assetName: text("asset_name").notNull(),
  description: text("description"),
  category: text("category", {
    enum: ["vehicle", "equipment", "furniture", "building", "land", "other"],
  }).notNull(),
  // #301 — optional FK to accounting_asset_categories. When set, create
  // handler defaults depreciationMethod / usefulLifeMonths / depreciation
  // accounts from the category (user can still override per-asset). The
  // legacy `category` enum stays for backward compat; new UI picks via
  // categoryId + the enum gets derived or deprecated later.
  categoryId: text("category_id"),
  purchaseDate: text("purchase_date").notNull(),
  purchasePrice: real("purchase_price").notNull().default(0),
  residualValue: real("residual_value").notNull().default(0),
  usefulLifeMonths: integer("useful_life_months").notNull().default(60),
  depreciationMethod: text("depreciation_method", {
    enum: ["straight_line", "declining_balance", "double_declining"],
  }).notNull().default("straight_line"),
  // GL account links
  assetAccountId: text("asset_account_id"),  // FK to accounts (e.g., 1800)
  depreciationAccountId: text("depreciation_account_id"),  // expense account (e.g., 5500)
  accumulatedDepAccountId: text("accumulated_dep_account_id"),  // contra asset (e.g., 1810)
  // Status
  status: text("status", {
    enum: ["active", "disposed", "fully_depreciated"],
  }).notNull().default("active"),
  // Disposal
  disposalDate: text("disposal_date"),
  disposalPrice: real("disposal_price"),
  disposalGainLoss: real("disposal_gain_loss"),
  // Fleet link (optional)
  vehicleId: text("vehicle_id"),
  // Audit
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  fa_company_status_idx: index("fa_company_status_idx").on(table.companyId, table.status),
  fa_company_category_idx: index("fa_company_category_idx").on(table.companyId, table.category),
  fa_vehicle_idx: index("fa_vehicle_idx").on(table.vehicleId),
  fa_company_asset_code_idx: uniqueIndex("fa_company_asset_code_idx").on(table.companyId, table.assetCode),
}));

// Type exports
export type FixedAsset = typeof fixedAssets.$inferSelect;
export type NewFixedAsset = typeof fixedAssets.$inferInsert;
